import { TooltipProps, Tooltip } from "@mui/material";
import { FC } from "react";

const JTooltip: FC<TooltipProps> = ({ children, ...props }) => {
  return (
    // eslint-disable-next-line jamezz/prefer-jamezz-component
    <Tooltip disableInteractive enterDelay={0} enterTouchDelay={0} {...props}>
      {children}
    </Tooltip>
  );
};

export default JTooltip;
